class customOrderEstimate {
	container = document.querySelector('#custom-order-estimate');

	constructor({ customer, metafields, product, rank, type }) {
		Object.assign(this, { customer, metafields, product: JSON.parse(product), rank, type });

		this.result = this.container.querySelector('.result');
		this.submit = this.container.querySelector('.submit');

		this.container.querySelector('[data-trigger="calc"]').addEventListener('click', async () => {
			await this.calc();
		});

		const accept = this.submit.querySelector('[name="accept"]');
		if (accept !== null) {
			accept.addEventListener('change', evt => {
				this.submit.querySelector('button').disabled = !evt.target.checked;
			});
		}

		this.submit.querySelector('button').addEventListener('click', async e => {
			if (e.target.dataset.trigger === 'estimate') {
				return;
			}
			const cart = await (await fetch('/cart.js')).json();
			if (cart.item_count > 0) {
				alert('通常商品・オーダーメイド商品は同時注文することができません。\nお手数ですが、カートを空にし再度カートイン頂くか、すでにカートインされた商品の購入手続きをお願いします。');
				return;
			}

			const spec = this.container.querySelector('[name="specification"]:checked');
			if (spec !== null) {
				const value = spec.dataset.group;
				const target = this.container.closest('form').querySelector('[name="properties[規格サイズ]"]');
				if (target === null) {
					this.container.closest('form').append(this.create('input', { name: 'properties[規格サイズ]', type: 'hidden', value }));
				} else {
					target.value = value;
				}
			}

			this.container.closest('form').submit();
		});

		this.toggleHatome();
		this.toggleSpecification();
		this.toggleSuso();

		this.container.closest('form').addEventListener('change', e => {
			if (e.target.name === 'accept') {
				return;
			}
			this.result.classList.add('hide');
			this.submit.classList.add('hide');
		})
	};

	async calc() {
		this.result.classList.add('hide');
		this.submit.classList.add('hide');

		if (this.validate() > 0) {
			this.scroll(this.container);
			return;
		}

		const target = selector => this.container.querySelector(selector);
		const formdata = new FormData(this.container.closest('form'));
		const calcdata = new URLSearchParams;

		calcdata.set('id', formdata.get('id'));
		calcdata.set('quantity', formdata.get('quantity'));
		calcdata.set('customer_rank', this.rank);

		if (this.type === 'sheet') {
			calcdata.set('color', target(`[value="${formdata.get('properties[色]')}"]`).dataset.id);
			calcdata.set('color_adjust_flag', this.metafields.color_adjust_flag);
			calcdata.set('hatome_pitch', formdata.get('properties[ハトメピッチ（m）]'));
			calcdata.set('length_val', formdata.get('properties[タテ（m）]'));
			calcdata.set('length_max', this.metafields.length);
			calcdata.set('length_limit_flag', this.metafields.length_limit_flag);
			calcdata.set('width_val', formdata.get('properties[ヨコ（m）]'));
			calcdata.set('width_max', this.metafields.width);
			calcdata.set('width_limit_flag', this.metafields.width_limit_flag);
			calcdata.set('glam_area', this.metafields.glam_area);
			calcdata.set('basis_price', this.metafields.basis_price);

			const around = target(`[value="${formdata.get('properties[周囲加工]')}"]`);
			calcdata.set('around', around.dataset.id);
			calcdata.set('hatome_check', 0);
			if (
				(around.dataset.eyelet == 1 && around.dataset.eyelet_check == 0) ||
				(around.dataset.eyelet == 1 && around.dataset.eyelet_check == 1 && target('[name="hatome-check"]') === true)
			) {
				calcdata.set('hatome_check', 1);
			}
		}
		if (this.type === 'box') {
			calcdata.set('color', target(`[value="${formdata.get('properties[色]')}"]`).dataset.id);
			calcdata.set('color_adjust_flag', this.metafields.color_adjust_flag);
			calcdata.set('front', formdata.get('properties[間口（m）]'));
			calcdata.set('front_max', this.metafields.front);

			const suso = target(`[value="${formdata.get('properties[スソ部加工]')}"]`).dataset.id;
			calcdata.set('suso', suso);
			if (suso != 4) {
				calcdata.set('front_process', target(`[value="${formdata.get('properties[間口加工]')}"]`).dataset.id);
			}

			calcdata.set('depth', formdata.get('properties[奥行（m）]'));
			calcdata.set('depth_max', this.metafields.depth);
			calcdata.set('height', formdata.get('properties[高さ（m）]'));
			calcdata.set('height_max', this.metafields.height);
			calcdata.set('glam_area', this.metafields.glam_area);
			calcdata.set('basis_price', this.metafields.basis_price);
		}
		if (this.type === 'print') {
			calcdata.set('size_flag', this.metafields.has_size_flag);
			calcdata.set('hatome_pitch', formdata.get('properties[ハトメピッチ（m）]'));
			calcdata.set('short', formdata.get('properties[短辺（m）]'));
			calcdata.set('long', formdata.get('properties[長辺（m）]'));

			const fabric = target(`[value="${formdata.get('properties[印刷生地]')}"]`);
			calcdata.set('fabric', fabric.dataset.id);
			calcdata.set('glam_area', fabric.dataset.weight);

			const around = target(`[value="${formdata.get('properties[周囲加工]')}"]`);
			calcdata.set('around', around.dataset.id);
			calcdata.set('hatome_check', 0);
			if (
				(around.dataset.eyelet == 1 && around.dataset.eyelet_check == 0) ||
				(around.dataset.eyelet == 1 && around.dataset.eyelet_check == 1 && target('[name="hatome-check"]') === true)
			) {
				calcdata.set('hatome_check', 1);
			}
		}

		let options = this.container.querySelector('[name="properties[オプション]"]');
		if (options === null) {
			options = Object.assign(document.createElement('input'), { name: 'properties[オプション]', type: 'hidden' });
			this.container.append(options);
		}
		options.value = formdata.getAll('options').join('、');
		formdata.getAll('options').map(e => calcdata.append('custom_option[]', target(`[value="${e}"]`).dataset.id));

		try {
			const param = {
				method: 'POST',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				body: calcdata.toString()
			};
			const res = await (await fetch('/apps/hagihara-proxy/%t/order_calc'.replace('%t', this.type), param)).json();
			if (res.status === 'error') {
				let error = [];
				const appendErr = (target, array) => {
					const e = this.create('div', { className: 'err', innerHTML: array.join('<br>') });
					this.container.querySelector(target).closest('fieldset').append(e);
				};

				res?.id !== undefined && (error = [...error, ...res.id]);
				res?.size_flag !== undefined && (error = [...error, ...res.size_flag]);
				res?.glam_area !== undefined && (error = [...error, ...res.glam_area]);

				res?.color !== undefined && appendErr('[name="properties[色]"]', res.color);
				res?.around !== undefined && appendErr('[name="properties[周囲加工]"]', res.around);
				res?.hatome_pitch !== undefined && appendErr('[name="properties[ハトメピッチ（m）]"]', res.hatome_pitch);
				res?.length_val !== undefined && appendErr('[name="properties[タテ（m）]"]', res.length_val);
				res?.width_val !== undefined && appendErr('[name="properties[ヨコ（m）]"]', res.width_val);

				res?.front !== undefined && appendErr('[name="properties[間口（m）]"]', res.front);
				res?.depth !== undefined && appendErr('[name="properties[奥行（m）]"]', res.depth);
				res?.height !== undefined && appendErr('[name="properties[高さ（m）]"]', res.height);
				res?.suso !== undefined && appendErr('[name="properties[スソ部加工]"]', res.suso);
				res?.front_process !== undefined && appendErr('[name="properties[間口加工]"]', res.front_process);

				res?.fabric !== undefined && appendErr('[name="properties[印刷生地]"]', res.fabric);

				if (this.metafields.has_size_flag == 1) {
					if (res?.short !== undefined || res?.long) {
						appendErr('[name="properties[短辺（m）]"]', [...res.short, ...res.long]);
					}
				} else {
					res?.short !== undefined && appendErr('[name="properties[短辺（m）]"]', res.short);
					res?.long !== undefined && appendErr('[name="properties[長辺（m）]"]', res.long);
				}

				res?.custom_option !== undefined && appendErr('[name="options"]', res.custom_option);
				res?.quantity !== undefined && appendErr('[name="quantity"]', res.quantity);

				if (error.length > 0) {
					alert(error.join('\n'));
				}
				this.scroll(this.container);
				return;
			}

			this.container.querySelector('#weight').innerHTML = res.weight_text;
			this.container.querySelector('#qty').innerHTML = formdata.get('quantity') + "個";
			this.container.querySelector('#total-offtax').innerHTML = res.total_text_excluded_tax;
			this.container.querySelector('#total-ontax').innerHTML = res.total_text;
			this.container.querySelector('#__weight').value = res.weight_text;
			this.container.querySelector('#__total').value = res.sub_total;

			this.result.classList.remove('hide');
			this.submit.classList.remove('hide');

			this.createPdf(formdata, res);
			this.scroll(this.result);

		} catch (err) {
			console.error(err);
		}

		this.result.classList.remove('hide');
		this.submit.classList.remove('hide');
	};

	create(tagname, param = {}) {
		return Object.assign(document.createElement(tagname), param);
	};

	createPdf(formdata, result) {
		if (__st?.cid === undefined || __st.cid === null) {
			return false;
		}
		if (this.container.querySelector('[data-trigger="estimate"]') === null) {
			return false;
		}

		const form = document.querySelector('#pdf_output_form');
		const obj = { properties: {}, product_title: this.product.title, quantity: formdata.get('quantity'), handle: this.product.handle };

		if (this.type === 'sheet') {
			obj.properties = {
				'色': formdata.get('properties[色]'),
				'周囲加工': formdata.get('properties[周囲加工]'),
				'ハトメピッチ（m）': formdata.get('properties[ハトメピッチ（m）]'),
				'タテ（m）': formdata.get('properties[タテ（m）]'),
				'ヨコ（m）': formdata.get('properties[ヨコ（m）]'),
				'カスタムオプション': formdata.getAll('options').join('、'),
				'重量（一個あたり）': result.weight_text,
				'最終金額': result.sub_total
			};
		}

		if (this.type === 'box') {
			obj.properties = {
				'色': formdata.get('properties[色]'),
				'スソ部加工': formdata.get('properties[スソ部加工]'),
				'間口加工': formdata.get('properties[間口加工]'),
				'間口（m）': formdata.get('properties[間口（m）]'),
				'奥行（m）': formdata.get('properties[奥行（m）]'),
				'高さ（m）': formdata.get('properties[高さ（m）]'),
				'カスタムオプション': formdata.getAll('options').join('、'),
				'重量（一個あたり）': result.weight_text,
				'最終金額': result.sub_total
			};
		}

		if (this.type === 'print') {
			form.action = '/apps/hagihara-proxy/print/pdf_output';
			obj.properties = {
				'印刷生地': formdata.get('properties[印刷生地]'),
				'周囲加工': formdata.get('properties[周囲加工]'),
				'ハトメピッチ（m）': formdata.get('properties[ハトメピッチ（m）]'),
				'短辺（m）': formdata.get('properties[短辺（m）]'),
				'長辺（m）': formdata.get('properties[長辺（m）]'),
				'カスタムオプション': formdata.getAll('options').join('、'),
				'重量（一個あたり）': result.weight_text,
				'最終金額': result.sub_total
			};
		}

		form.querySelector('[name="product_data"]').value = JSON.stringify({ items: [obj] });

		return true;
	};

	echo(obj) {
		console.log(0, Object.fromEntries(obj));
		console.log(1, obj.getAll('custom_option[]'));
		console.log(2, obj.toString());
	};

	scroll(e, offset = 0) {
		const header = document.querySelector('.shopify-section__header');
		window.scroll({
			top: e.getBoundingClientRect().top + window.scrollY - header.offsetHeight + offset,
			behavior: 'smooth'
		});
	};

	toggleHatome() {
		const trigger = this.container.querySelector('.hatome');
		if (trigger === null) {
			return;
		}

		const target = trigger.nextElementSibling;
		const checkbox = target.querySelector('[type="checkbox"]');
		const parent = checkbox.closest('label');
		const input = target.querySelector('[type="number"]');

		for (const e of [...trigger.querySelectorAll('[type="radio"]')]) {
			e.addEventListener('change', () => {
				const { eyelet, eyelet_check } = e.dataset;
				
				target.classList.add('hide');
				parent.classList.add('hide');
				input.value = 0.9;
				input.disabled = true;
				checkbox.checked = false;

				if (eyelet == 1) {
					target.classList.remove('hide');
					if (eyelet_check == 0) {
						input.disabled = false;
					}
				}
				if (eyelet_check == 1) {
					parent.classList.remove('hide');
				}
			});
		}

		checkbox.addEventListener('change', () => input.disabled = !checkbox.checked);
	};

	toggleSpecification() {
		const container = this.container.querySelector('.specification');
		if (container === null) {
			return;
		}

		const tabs = container.querySelectorAll('.custom-order-container--tab input');
		const targets = container.querySelectorAll('.custom-order-container--tab-container input');

		const changeValue = e => {
			const [size0, size1] = e.value.split(',').sort((a, b) => {
				if (a < b) return -1;
				if (a > b) return 1;
				return 0;
			});
			container.querySelector('[name="properties[短辺（m）]"]').value = size0;
			container.querySelector('[name="properties[長辺（m）]"]').value = size1;

			container.querySelector('.select--specification [data-trigger="short"]').innerHTML = `${size0 * 100}cm`;
			container.querySelector('.select--specification [data-trigger="long"]').innerHTML = `${size1 * 100}cm`;
		};

		[...tabs].map(e => e.addEventListener('change', () => {
			const { group } = e.dataset;

			[...targets].map(target => target.closest('label').classList.add('hide'));

			const actives = [...targets].filter(e => e.closest('label').dataset.group === group);
			actives.map(target => target.closest('label').classList.remove('hide'));
			if (actives.length > 0) {
				actives[0].checked = true;
				changeValue(actives[0]);
			}
		}));

		[...targets].map(e => e.addEventListener('change', () => changeValue(e)));
	};

	toggleSuso() {
		const trigger = this.container.querySelector('[name="properties[スソ部加工]"]');
		const target = this.container.querySelector('[name="properties[間口加工]"]');

		if (trigger === null || target === null) {
			return;
		}
		trigger.addEventListener('change', () => {
			target.disabled = trigger.querySelector(`[value="${trigger.value}"]`).dataset.id == 4;
		});
	};

	validate() {
		[...this.container.querySelectorAll('.err')].map(e => e.remove());

		[...this.container.querySelectorAll('[data-err]')].map(e => {
			if (
				(e.querySelector('[type="number"]') !== null && e.querySelector('[type="number"]').value === '') ||
				(e.querySelector('[type="radio"]') !== null && e.querySelectorAll('[type="radio"]:checked').length === 0) ||
				(e.querySelector('select') !== null && e.querySelector('select').value === '')
			) {
				if (e.querySelector('select') !== null && e.querySelector('select').name === 'properties[間口加工]') {
					const trigger = this.container.querySelector('[name="properties[スソ部加工]"]');
					if (trigger !== null && this.container.querySelector(`[value="${trigger.value}"]`).dataset.id == 4) {
						return;
					}
				}
				e.append(this.create('div', { className: 'err', innerHTML: e.dataset.err }));
				return;
			}

			const input = e.querySelector('[type="number"]');
			if (input === null || input.value === '') {
				return;
			}

			if (input.name.includes('quantity') !== true && input.value.split('.').length > 1 && input.value.split('.')[1].length > 2) {
				const key = input.name.replace('properties[', '').replace(']', '');
				e.append(this.create('div', { className: 'err', innerHTML: `※${key}は、小数第二位までの値を入力してください` }));
			}
			if (input.name.includes('ハトメピッチ') === true && +input.min > +input.value) {
				e.append(this.create('div', { className: 'err', innerHTML: '※ハトメピッチは、0.1m以上の値を入力してください' }));
			}
		});
		return this.container.querySelectorAll('.err').length || 0;
	};
};